import NestedForm from 'stimulus-rails-nested-form'

export default class extends NestedForm {
  static values = { min: Number, max: Number }
  static targets = ["trashButton", "addButton"]

  connect() {
    super.connect()
    this.initialDisableButtons()
  }

  add(event) {
    super.add(event)
    this.disableButtons()
  }

  remove(event) {
    super.remove(event)
    this.disableButtons()
  }

  disableButtons() {
    const elements = $(`${this.wrapperSelectorValue}:visible`)
    if (elements.length == this.min) {
      this.trashButtonTargets.forEach((button) => { button.disabled = true })
    } else {
      this.trashButtonTargets.forEach((button) => { button.disabled = false })
    }

    this.hideAddButton()
  }

  initialDisableButtons() {
    const elements = $(`${this.wrapperSelectorValue}`)

    if (elements.length <= this.min) {
      this.trashButtonTargets.forEach((button) => { button.disabled = true })
    }

    this.hideAddButton()
  }

  hideAddButton() {
    const elements = $(`${this.wrapperSelectorValue}:visible`)

    if (this.hasMaxValue && this.hasAddButtonTarget) {
      if (elements.length >= this.maxValue) {
        this.addButtonTarget.classList.add("d-none")
      } else {
        this.addButtonTarget.classList.remove("d-none")
      }
    }
  }

  get min() {
    return this.hasMinValue ? this.minValue : 0
  }
}
